import { LOAD_PUBLIC_SETTINGS, UPDATE_ADMIN_SETTING } from "../action/Types";

const initialState = {
  registerEnabled: true,
  loading: true,
};

export default function SettingsReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case LOAD_PUBLIC_SETTINGS:
      return {
        ...state,
        registerEnabled: payload.registerEnabled,
        loading: false,
      };
    case UPDATE_ADMIN_SETTING:
      return {
        ...state,
        registerEnabled: payload.registerEnabled,
        loading: false,
      };
    default:
      return state;
  }
}
